









import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

// api
import { mapData, REPORT_API_MAPPING } from '@/api/Mapping'

// Helpers
import { Meta } from '@/helpers/decorators'

// Model
import Report from '@/models/Report'

// Views
import TemplateCategoriesBox from '@/views/all/boxes/TemplateCategoriesBox.vue'
import TemplateReport from '@/views/report/partials/Report.vue'

@Component({
  components: { TemplateCategoriesBox, TemplateReport }
})
export default class CreateReport extends Vue {
  report = null
  changes = []
  templateID = null

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale
  @Action('loadTemplate', { namespace: 'report' }) loadTemplateFromStore

  @Watch('templateID')
  async fetchTemplateID(id) {
    if (id) {
      this.report = await this.loadTemplateFromStore(this.templateID)
    }
  }

  @Watch('locale')
  async updateTemplate() {
    this.report = await this.loadTemplateFromStore(this.templateID)
  }

  async updateParts() {
    try {
      const res = await this.$api.reports.saveReportFromTemplate(this.token, this.templateID)
      await this.$api.reports.updateReportParts(this.token, res.data.proov_code, this.changes)
      this.$router.push({ name: 'singleReport', params: { id: res.data.proov_code } })
    } catch (e) {
      console.log(e)
    }
  }

  async saveParts(changes) {
    this.changes = changes
    await this.updateParts()
  }

  loadTemplate(report) {
    this.templateID = report.template.id
  }
}
